import { Component } from '@angular/core';
import { LoaderService } from './shared/_services/loader.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'Zoodlekid';
  isLoading: Observable<boolean> = this.loaderService.isLoading;
  constructor(
    private loaderService: LoaderService,
    private ngxService: NgxUiLoaderService
  ) {}

  ngOnInit() {
    this.isLoading.subscribe((value: boolean) => {
      if (value) {
        this.ngxService.start();
      } else {
        this.ngxService.stop();
      }
    });
  }
}
